import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { ProcedureModel as Model } from './Model'


export const MODULE_NAME = 'procedures'

export const PROCEDURES_PAGES_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
} as const

export const MENU = {
  id: PROCEDURES_PAGES_ROUTES.LAYOUT,
  route: { name: PROCEDURES_PAGES_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-book-open-blank-variant',
} as const

export const createProcedureModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PassportRefreshModal" */
    './components/ProcedureModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
